// The order of the sidebar, the same in every app (docs/61, decided by Bastian on 2026-10-20; SidebarLayout.swift is
// the reference). Only what the user made is a group with a heading that folds: Favorites and each area. The app's own
// lists stand in blocks without a label. Whether Stale, Someday, Templates and the Archive show at all stays the
// screens' decision (the settings, Pro, whether there are any); this gives only their place.

import type { Route } from "./lists";

/** Inbox, Today, Habits, Deadlines: what waits. Habits after Today, since both are about today (docs/63, board 10). */
export const SIDEBAR_TOP: readonly Route[] = [{ kind: "inbox" }, { kind: "today" }, { kind: "habits" }, { kind: "due" }];
/** Scheduled, Anytime, Someday: after the favorites. */
export const SIDEBAR_MIDDLE: readonly Route[] = [{ kind: "scheduled" }, { kind: "anytime" }, { kind: "someday" }];
/** The list that leads the areas' block: Miscellaneous. */
export const SIDEBAR_AREAS_LEAD: Route = { kind: "general" };
/** Stale, Templates, Archive: under the areas, at the bottom. */
export const SIDEBAR_BOTTOM: readonly Route[] = [{ kind: "stale" }, { kind: "templates" }, { kind: "archive" }];

/**
 * One block of the sidebar: lists of the app's own without a heading; the favorites under the heading "Favorites" (⭐)
 * that folds (kept per browser); Miscellaneous and then the areas, each a heading that folds.
 */
export type SidebarPart = { kind: "lists"; routes: readonly Route[] } | { kind: "favorites" } | { kind: "areas" };

/** The blocks in order. */
export const SIDEBAR_PARTS: readonly SidebarPart[] = [
  { kind: "lists", routes: SIDEBAR_TOP },
  { kind: "favorites" },
  { kind: "lists", routes: SIDEBAR_MIDDLE },
  { kind: "areas" },
  { kind: "lists", routes: SIDEBAR_BOTTOM },
];

/** The emoji in the place of an area's icon on the Favorites heading. */
export const FAVORITES_EMOJI = "⭐";
